export const UserServiceParams = {
  getSearchUrl: (apiEndpoint: string, searchQuery?: string) => {
    const params = `?page=0&size=5&search=${searchQuery}`
    return `${apiEndpoint}/api/adherents/users${params}`
  },
  getCreateUrl: (apiEndpoint: string) => `${apiEndpoint}/api/adherents/users`,
}
